import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';

function EarlyExitPinModal({ open, handleClose, onConfirm }) {
  const [pin, setPin] = useState(['', '', '', '']);

  const handlePinChange = (index, value) => {
    if (value.length > 1) return;
    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    // Auto-focus next input
    if (value && index < 3) {
      const nextInput = document.getElementById(`early-exit-pin-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !pin[index] && index > 0) {
      const prevInput = document.getElementById(`early-exit-pin-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const isPinComplete = pin.every(digit => digit !== '');

  const handleConfirmClick = () => {
    if (isPinComplete) {
      setPin(['', '', '', '']);
      onConfirm();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 400,
          bgcolor: 'background.paper',
          borderRadius: '24px',
          boxShadow: 24,
          p: 4,
          outline: 'none',
        }}>
          {/* Header */}
          <div className="flex items-center mb-8">
            <span onClick={handleClose} className="cursor-pointer text-gray-800 text-[14px] font-bold flex items-center gap-2">
              &larr; Back
            </span>
            <div className="ml-auto">
              <div onClick={handleClose} className="w-8 h-8 rounded-full bg-[#1E222B] text-white flex items-center justify-center cursor-pointer">
                <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L13 13M1 13L13 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </div>

          <div className="text-center mb-8">
            <h2 className="text-[#1E222B] text-[20px] font-bold mb-2">Enter your PIN</h2>
            <p className="text-[#808285] text-[13px]">
              Enter your 4-digit PIN to confirm listing
            </p>
          </div>

          {/* PIN Input */}
          <div className="flex justify-center gap-4 mb-10">
            {pin.map((digit, index) => (
              <input
                key={index}
                id={`early-exit-pin-${index}`}
                type="password"
                maxLength={1}
                value={digit}
                onChange={(e) => handlePinChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                className="w-14 h-14 border-2 border-gray-200 rounded-xl text-center text-[24px] font-bold text-back-color2 focus:border-[#00BC67] focus:outline-none transition-colors"
              />
            ))}
          </div>

          {/* Confirm Button */}
          <button 
            onClick={handleConfirmClick}
            disabled={!isPinComplete}
            className={`w-full py-3.5 rounded-lg font-[600] text-[15px] transition-colors ${
              isPinComplete 
                ? 'bg-[#00BC67] text-white' 
                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
          >
            Confirm
          </button>
        </Box>
      </Fade>
    </Modal>
  );
}

export default EarlyExitPinModal;
